const zh = {
    10000001: 'SuperEx二周年庆',
    10000002: '签到领取丰厚奖励！',
    10000003: '根據參賽人數解鎖對應獎池，參賽人數越多解鎖獎池越大，最高10,000USDT獎金池',
    10000004: 'SuperEx 兩週年',
    10000005: '合約慶典賽贏取20,000USDT',
    10000006: `交易量排名赛，解锁最高 <span style="color: #ffc72b;">10,000</span> USDT 奖金池`,
    10000007: '合約冠軍賽',
    10000008: '贏取20,000USDT獎池！',

    10000009: '请选择',
    10000010: '发行总量',
    10000011: '区块查询',
    10000012: '返回',
    10000013: '下一步',
    10000014: '上一步',
    10000015: '填写信息',
    10000016: '请输入币种简称',
    10000017: '请输入币种全称',
    10000018: '知道了',
    10000019: '请输入副本标题',
    10000020: '请输入币种流通量',
    10000021: '完成',
    10000022: '之后，关于该交易对的统计数据您可以前往WEB端官网的自由区页面中查看。',
    10000023: '{currency} 已上所',
    10000024: '年',
    10000025: '月',
    10000026: '日',

    8000067: '数据统计',
    8000068: '币种简称',
    8000069: '公链或协议',
    8000070: '合约地址或TICKER',
    8000071: '副本标题',
    8000072: '副本创建时间',
    8000073: '副本状态',
    8000074: '累计分红金额/U',
    8000075: '上周分红金额/U',
    8000076: '上周交易金额/U',
    8000077: '上周交易笔数',
    8000078: '创建交易对',
    8000079: '延期',
    8000080: '已上架',
    8000081: '即将下架',
    8000082: '已下架',
    8000083: '确认币种',
    8000084: '上币提示',
    8000085: '创建成功',
    8000086: '自由区上币',
    8000087: '在SuperEx，您可以既轻松又免费的完成交易所上币，并有机会获得最高80%的交易手续费分红',
    8000088: '如何上币？',
    8000089: '创建新的交易对',
    8000090: '我要上币',
    8000091: '创建交易对副本',
    8000092: 'SuperEx交易所',
    8000093: '为何选择我们？',
    8000094: '多样选择',
    8000095: '支持多链和协议，包括BSC链，ETH链，SOL链',
    8000096: '无需人工审核，即刻上币，感受去中心化般的上币流程和订单簿下单的便利性。',
    8000097: '支持API',
    8000098: '您可以通过API接口来进做市或交易，这使您的操作更加高效和自动化。',
    8000099: '平台曝光',
    8000100: '在现货自由区上币，享受SuperEx的千万用户流量并获得更多关注。',
    8000101: '无论您是新手还是经验丰富的交易者，我们的现货自由区都将为您带来新的体验和投资机会。立即创建属于您自己的交易对，推广您心爱的代币并享受交易手续费的分红收益！',
    8000102: '您的总资产折合需要大于{resultData}U后，才有资格创建交易对',
    8000103: '上交易所',
    8000104: '您可以选择自己喜欢的币种，并与USDT组合成交易对，从而创造出独特的交易体验',
    8000105: '获得手续费分红',
    8000106: '当您创建的交易对副本的交易额达到一定门槛后，一部分交易手续费将作为分红返还给您。这样就让作为交易对副本创建者的您也能分享交易收益。',
    8000107: '您当前是被限制用户，暂时无法创建新交易对，请明天再试。',
    8000108: '请选择语言',
    8000109: '白皮书',
    8000110: '该币种已被禁止上架！',
    8000111: '该币种已经在SuperEx主板交易区中存在，无法再创建交易对！',
    8000112: '请输入有效的合约地址/Ticker',
    8000113: '您的现货主板区ET余额不足， 创建新交易对需要支付 {num} ET管理费用，请充值后再来',
    8000114: '您今天创建新币的过程中错误输入的次数太多， 因此今天您不能再进行创建新币的申请，请明天再试。',
    8000115: '该币种已存在，现在将创建您的交易对副本！',
    8000116: '请确认以下信息：',
    8000117: '币种数量的小数位长度',
    8000118: '如何自由上币',
    8000119: '币种全称',
    8000120: '币种价格的小数位长度',
    8000121: 'SUPEREX上币：<em class="normal" style="color: #0CAA6D;">0上币费用！</em><em class="normal" style="color: #1D90F5;">0沟通成本！</em>1分钟即可完成交易所上币，还可享受最高<em class="normal" style="color: #F65D62;">80%的收益分红</em>',
    8000122: '英文币种简介',
    8000123: '以下为必填信息：',
    8000124: '你输入的副本标题已存在，请重新输入！',
    8000125: '以下为选填信息：',
    8000126: '请选择主链或协议，以及对应的管理费',
    8000127: '第一步 :複制并粘贴那个新币的合约地址。',
    8000128: '请输入合约地址/Ticker',
    8000129: '确认创建',
    8000130: '您的交易对副本 {currency} 已创建成功！',
    8000131: '第二步 : 如果该币种是首次上交易所，您需要补充完成几个基础信息，如币种简介和上传LOGO图片。',
    8000132: 'BTC协议市场',
    8000133: '第三步 : 您只需要为您所创建的这个交易对副本命名即可。然后，上币就结束了，该币就可以面向公众开放交易了。',
    8000134: '自由上币',
    8000135: '请输入发行总量',
    8000136: '第四步 : 当您的副本的每周交易额达到了一个门槛阈值后，您就会收到该副本的交易手续费分成。',
    8000137: '如果您选择了8，则代表您的币种价格的数值显示精确到0.00000001。例如，BTC的价格显示为$72186.12345678。对于大多数MEME币，我们建议您选择11即可。',
    8000138: '请输入',
    8000139: '我要开始上币了',
    8000140: '请输入英文币种简介',
    8000141: '您可以把“副本”简单理解为同一个交易对可以有多个版本，其中的一个版本就是您创建的副本。其他用户通过副本名称来区别这些版本。只要用户选择了您的副本进行交易，您就有机会获得相应的手续费分红。',
    8000142: '邮件格式不正确',
    8000143: '请输入区块查询地址',
    8000144: '币种流通量',
    8000145: '币种流通量限制输入1-20位正整数',
    8000146: '币种图标',
    8000147: '支持png或jpg格式，大小在5 MB以内，每日仅限10次上传',
    8000148: '币种发行时间',
    8000149: '请选择发行时间',
    8000150: '请输入白皮书链接',
    8000151: '官方网站',
    8000152: '请输入官网链接',
    8000153: '现货自由区上币',
    8000154: '让您的币种在交易所上币',
    8000155: '币种简称的输入限制为9位字符，仅支持数字，英文字母和英文符号',
    8000156: '币种全称的输入限制为50位字符，仅支持数字，空格，英文字母和英文符号',
    8000157: '发行总量限制输入1-20位的正整数',
    8000158: '开头或结尾字符不能是空格，并且不能有连续的空格；不支持“/”符号和表情符号',
    8000159: '1. 上币者需要自己对信息真实性负责，并且平台有权利随时下架币种或交易对，平台有权利随时调整信息内容。',
    8000160: '2. 上币者需要对所上币种进行充分调研，并对其的合理、合规和合法性负责。如果平台发现币种的智能合约有各种恶意的或者伤害性的行为，会直接将其下架，并代表用户对上币者进行索赔。',
    8000161: '3. 上币者或者其他人如果之后想对币种信息做调整，需要联系我们的客服。',
    8000162: '4. 为了保护用户的利益和淘汰不良币种，上币者创建的交易对如果不符合我们平台的成交量的要求标准，就会在约一周后的时间被通知下架。每周一的时候，平台会对不符合的交易对发出下架通知，届时上币者在5天内还有机会可以对其申请延迟下架。 如果申请延迟下架成功，会获得额外4周的上架观察时间，否则就会被下架。',
    8000163: '5. 上币者创建的交易对副本如果其交易额满足了平台的分红标准门槛，将会收到对应的手续费分红。',
    8000164: '您是否愿意提供一定数量的代币用于运营活动及市场推广，以便扩大该币的影响力呢？',
    8000165: '6. 上币者可以联系平台客服申请做市商的资格。',
    8000166: '创建',
    8000167: '即将创建交易对副本{currency}并于您的现货主板区账户中扣除{upFee}ET！',
    8000168: '否',
    8000169: '是',
    8000170: '请输入您的电子邮箱，届时我们的市场运营人员将与您联系',
    8000171: '您是否有推荐人或对接人？',
    8000172: '请输入推荐人名称或联系方式',
    8000173: '勾选此框,表明您愿意承担所有相关风险,并同意我们的 <a id="service_href" class="pointer" style="color: #D9A31A" target="_self">《条款和条件》</a>',
    8000174: '获得上币的收益',
    8000175: '在交易所上币的权利',
    8000176: '目前暂不支持该币种上架！',
    8000177: '填写信息',
    8000178: '去分享',
    8000179: '已上所!',
    8000180: '自由区上币，开启财富自由',
    8000181: '我在SuperEx上创建了交易对{symbol}，大家赶紧冲！',
    8000182: '每笔分红金额在周一更新数据，但实际发放过程中可能有最多3个工作日的延期情况。您可以在“钱包历史记录”-“其他”-"现货主板区“下面，通过“赠送奖励”类型来查看相关的记录。',
    8000183: 'Twitter账号',
    8000184: 'Telegram账号',
    8000185: 'Discord账号',
    8000186: '请输入有效的Twitter链接！',
    8000187: '请输入有效的Telegram链接！',
    8000188: '请输入有效的Discord链接！',
    8000189: '请输入Twitter链接',
    8000190: '请输入Telegram链接',
    8000191: '请输入Discord链接',
    8000192: '抱歉，该币种的智能合约的内容或相关权限设定有较高安全风险。请尝试使用其他币种。',
    8000193: '抱歉，该币种的智能合约的内容可能有潜在风险，目前无法上币。请尝试使用其他币种。',
    8000194: '注意事项：',
    8000195: '您需要完成这个币种的充值后，才能挂卖单',
    8000196: '您需要把USDT划转到自由区后，才能挂买单',
    8000197: '你需要对接API后，才能进行做市交易',
    8000198: '我要找客服沟通',
    8000199: '请输入5-12之间的一个整数',

    8100013: '官方验证通道',
    8100014: '请输入需要验证的信息',
    8100015: '您可以进行如下内容的验证',
    8100016: '仅限SUPEREX.COM官方邮件',
    8100017: '官方BD身份验证',
    8100018: '例如：Telegram/X（Twitter）官方身份',
    8100019: 'listing渠道验证',
    8100020: '如果您需要签订合同/付款，请务必和官方BD进行确认',
    8100021: '感谢您对<a href="/" style="color: #FFC72B" class="under-line pointer">SUPEREX.COM</a>的关注，我们会尽可能保护大家的权益不受到侵犯',
    8100022: '非SuperEx官方渠道',
    8100023: 'SuperEx官方渠道',
    8100024: '您输入的<em class="normal activeColor" style="word-break: break-word">{keyWord}</em>并非SuperEx的官方渠道。请注意您的资产安全，保护好个人信息',
    8100025: '您查詢內容中的<em class="normal activeColor" style="word-break: break-word">{keyWord}</em>为{note}',
    8100026: '安全提示',
    8100027: '· 请不要与未经验证的账户交互。',
    8100028: '· 请勿将您的钱包助记词、SuperEx绑定的邮箱、手机号码和/或密码告知任何人。',
    8100029: '· 如需更多帮助，请联系客服支持support@superex.com。',
    8100030: '收到{userName}的大红包!',
    8100031: '开红包',
    8100032: '还差最后一步！',
    8100033: '即刻下载SuperEx，领取好友红包！',
    8100034: '放弃红包',
}
export default zh



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/zh.js